// src/reducers/authReducer.js

const initialState = {
  search: "",
  api: "",
};

const globalSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SEARCH":
      return {
        ...state,
        search: action.payload.search,
        api: action.payload.api,
      };
    case "EMPTY_GLOBAL_SEARCH":
      return {
        ...state,
        search: "",
        api: action.payload,
      };
    default:
      return state;
  }
};

export default globalSearchReducer;
